"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapRootElement = exports.wrapPageElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmetAsync = require("react-helmet-async");

var _baseSeo = require("./meta/base-seo");

var wrapPageElement = function wrapPageElement(_ref, options) {
  var element = _ref.element;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_baseSeo.BaseSeo, options), element);
};

exports.wrapPageElement = wrapPageElement;

var wrapRootElement = function wrapRootElement(_ref2) {
  var element = _ref2.element;
  return /*#__PURE__*/_react["default"].createElement(_reactHelmetAsync.HelmetProvider, null, element);
};

exports.wrapRootElement = wrapRootElement;